<template>
	<div class="page">
		<div class="searchView">
			<div class="tabLine">
				<div class="tabItem" :class="[order_source=='2'?'active':'']" @click="handleSelect('2')">余额充值</div>
				<div class="tabItem" :class="[order_source=='3'?'active':'']" @click="handleSelect('3')">押金充值</div>
			</div>
			<el-form class="searchBox">
				<el-row>
					<el-col :span="4">
						<el-form-item>
							<el-input style="width:130px;margin-right: 10px;" placeholder="请输入关键字" v-model="search.keyword" clearable @keyup.enter.native="changeSearch" size="small"></el-input>
							<el-button @click="changeSearch" type="warning" size="small">搜索</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="结算状态" :label-width="'70px'">
							<el-select class="select" v-model="search.state" @change="changeSearch" placeholder="请选择" style="width:90px;" size="small">
								<el-option v-for="item in [{label:'全部',value:-1},{label:'未结算',value:1},{label:'支付中',value:2},{label:'已结算',value:3}]" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="支付方式" :label-width="'70px'">
							<el-select class="select" v-model="search.pay_type" @change="changeSearch" placeholder="请选择" style="width:100px;" size="small">
								<el-option v-for="item in [{label:'全部',value:-1},{label:'现金',value:0},{label:'pos机',value:5},{label:'余额',value:7},{label:'电商平台',value:11},{label:'优惠',value:12},{label:'京东聚合',value:13},{label:'拉卡拉',value:17},{label:'嘉联',value:15}]" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="销售人员" :label-width="'80px'">
							<el-select v-model="saleValue" filterable placeholder="请选择" style="width: 100px;" @change="changeSearch" size="small">
								<el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.real_name" :value="item._id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="7">
						<el-form-item label="销售日期" :label-width="'90px'" >
							<el-date-picker
							size="small"
							@change="changeSearch"
							v-model="datetimerange"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期" style="width: 220px;">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<resetBtn @reset="reset" style="width:56px;display: inline-block;margin:0px 10px;"></resetBtn>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="pageConBox">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column prop="no" label="订单编号" width="160">
				</el-table-column>
				<el-table-column prop="name" label="顾客" width="170">
					<template slot-scope="scope">
						<div style="cursor: pointer;color: #409EFF;" @click="toUserDetail(scope.row.user_info.user_id)">
							{{scope.row.user_info.nick_name}}
							{{scope.row.user_info.user_mobile}}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="类型" width="70">
					<template slot-scope="scope">
						<span v-if="scope.row.order_source===2">充值</span>
						<span v-if="scope.row.order_source===3">押金</span>
					</template>
				</el-table-column>
				<el-table-column prop="price" label="总金额" width="100">
				</el-table-column>
				<el-table-column prop="zip" label="结算状态">
					<template slot-scope="scope">
						<!-- {{scope.row.state==3?'已结算':'未结算'}} -->
						<span v-if="scope.row.state == -2">已取消</span>
						<span v-if="scope.row.state == 1">未结算</span>
						<span v-if="scope.row.state == 2">支付中</span>
						<span v-if="scope.row.state == 3">已结算</span>
						<span v-if="scope.row.state == -3">退款中</span>
						<span v-if="scope.row.state == -4">退款成功</span>
					</template>
				</el-table-column>
				<el-table-column prop="zip" label="结算方式" width="140">
					<template v-if="scope.row.pay_info" slot-scope="scope">
						<div v-for="(item,index) in scope.row.pay_info.pay_list" :key="index">
							<span style="padding-right: 2px;">
								{{$public.formatPayTypeState(item.pay_type)}}
							</span>
							{{Math.abs((item.money).toFixed(2))}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注" width="110">
					<template slot-scope="scope">
						<el-popover placement="top-start" width="200" trigger="hover" :content="scope.row.remark">
							<div slot="reference" style="width:100px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;cursor: pointer;">{{scope.row.remark}}</div>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column label="销售日期" width="140">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.create_time)}}
					</template>
				</el-table-column>
				<el-table-column label="销售人员">
					<template slot-scope="scope">
						<div v-for="(item,index) in scope.row.sales_list" :key="index">
							<span>{{item.sales_name}} </span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="发票状态" width="70">
					<template slot-scope="scope">
						{{scope.row.isHaveInvoices==true?'已添加':'未添加'}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="scope">
						<el-button @click="$router.push({path:'/rechargeOrder/rechargeOrderSee',query:{id:scope.row._id}})" type="text" size="small">查看</el-button>
						<el-button v-if="is_jialian(scope.row)&&scope.row.state===2" @click="checkOrderState_Jialian(scope.row)" type="text" size="small">校验状态</el-button>
						<el-button v-if="scope.row.state==3" type="text" size="small" @click="getInvoice(scope.row)">打印小票</el-button>
						<el-button v-if="(scope.row.state==1 || scope.row.state==2)&&$buttonAuthority('dingdan-rechargeOrder-jiesuan')" @click="edit(scope.row)" type="text" size="small">结算</el-button>
						<el-button v-if="scope.row.state==3&&scope.row.other_param&&scope.row.other_param.is_give_coupon!=true&&$buttonAuthority('dingdan-rechargeOrder-zengsong')" @click="send(scope.row)" type="text" size="small">赠送</el-button>
						<!-- <el-button v-if="scope.row.state!=3" @click="del(scope.row._id)" type="text" size="small">删除</el-button> -->
						<el-button v-if="(scope.row.state==1 || scope.row.state==2)&&$buttonAuthority('dingdan-rechargeOrder-canle')" @click="handelCancelClick(scope.row)" type="text" size="small">取消</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-row>
				<el-col>
					<div style="padding:20px;font-size:14px;">本页合计：{{totalMoney}}</div>
				</el-col>
			</el-row>
			<page :total="page.total" :page="page.page" @change="changePage" style="padding-bottom: 10px;"></page>
		</div>
		<!-- 结算弹窗 -->
		<div>
			<dialogSettlement v-if="dialogSettlementState" :type="'recharge'" :canYue="false" :orderId="curOrder._id" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
		<div v-if="dialogSendCard">
			<dialogSendCard :row="curRow" @submit="submitSendCard"></dialogSendCard>
		</div>
		<!-- <iframe v-if="printUrl" :src="'ChuLinPrint:'+printUrl" width="0" height="0"></iframe> -->
	</div>
</template>
<script>
	// import util from "../../../../util/util.js"
	import page from "../../../../components/page.vue"
	import dialogSettlement from '../../../../components/dialog_settlement.vue'
	import dialogSendCard from "../../../../components/dialog_sendCard.vue"
	import resetBtn from "../../../../components/resetBtn.vue"
	import printJs from "../../../../util/print.js"
	export default {
		components:{page,dialogSettlement,dialogSendCard,resetBtn},
		data(){
			return{
				search:{
					"keyword": "",
					"userid": "",   // 用户id
					"starttime": "",
					"endtime": "",
					"state": -1, 
					"pay_type": -1, 
				},
				datetimerange: [],
				tableData:[],
				totalMoney:'',
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// 打印
				// printUrl:'',
				// 赠送
				dialogSendCard:false,
				curRow:{},
				// 支付
				curOrder:{},
				dialogSettlementState:false,
				order_source: '2', //tab切换下标
				staffList:[],  //员工列表
				saleValue:'',  //销售人员
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted(){
			this.getTableData();
			this.getStaffData();
		},
		methods: {
			//tab切换
			handleSelect(key){
				this.order_source = key;
				this.page.page = 1;
				this.getTableData()
			},
			//取消充值
			handelCancelClick(row){
				console.log('取消充值',row)
				this.$confirm('是否取消充值?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get('/api/Recharge/ReceivedRecharge', {
						orderId:row._id
					}).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '取消成功!'
							});
							this.getTableData()
						}
					})
				})
			},
			toUserDetail(id){
				this.$router.push({path:'/huiyuan/huiyuanSee',query:{id:id}});
			},
			// 赠送
			send(row){
				this.dialogSendCard=true;
				this.curRow = row;
			},
			submitSendCard(str){
				if(str==='close'){
					this.dialogSendCard=false;
				}else if(str==='success'){
					this.dialogSendCard=false;
					this.getTableData();
				}else{
					this.dialogSendCard=false;
				}
			},
			// 支付
			edit(row) {
				this.curOrder = row
				this.dialogSettlementState = true;
			},
			// 结算完成关闭弹窗
			dialogSettlementSubmit(a) {
				this.dialogSettlementState = false;
				if(a=='cancel'){
					console.log(a)
				}else if(a=='fail'){
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				}else if(a=='success'){
					this.$message({
						message: '结算成功',
						type: 'success'
					});
				}
				this.getTableData()
			},
			//重置
			reset(){
				this.page.page = 1;
				this.search.keyword = '';
				this.search.starttime = '';
				this.search.endtime = '';
				this.datetimerange=[];
				this.search.state = -1;
				this.search.pay_type = -1;
				this.saleValue = '';
				this.getTableData();
			},
			changeSearch(){
				this.page.page=1;
				this.getTableData()
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			// 获取列表数据
			getTableData() {
				let params = {
					"keyword": this.search.keyword,
					"userid": this.search.userid,   // 用户id
					starttime:'',
					endtime:'',
					"state": this.search.state, // 状态 -1 全部 1 未成功 3 已成功
					"pay_type": this.search.pay_type,  // 支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 7 余额 8 赠额 9 积分
					// order_source:this.order_source, // -1全部 2 余额 3押金
					shop_id:this.curShopId,
					"page_index": this.page.page,
					"page_size": this.page.pageSize,
					"sale_id": this.saleValue
				}
				if(this.datetimerange&&this.datetimerange.length==2){
					params.starttime=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
					params.endtime=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				}
				let loading = this.$loading();
				this.$http.post(process.env.VUE_APP_Url_order+'/api/OffLineRecharge/list', params).then(res => {
					loading.close();
					if (res.code == 0) {
						console.log(res.data.data)
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.getPageTotalMoney();
					}
				})
			},
			//获取员工列表
			getStaffData() {
				let params = {
					keyword:this.saleValue,
					pageIndex:0,
					pageSize:500
				}
				this.$http.get('/api/Staff/List',params).then(res => {
					// console.log(res)
					if(res.code == 0){
						this.staffList = res.data.data;
					}
				})
			},
			// 获取本页合计
			getPageTotalMoney(){
				let totalMoney = 0;
				for(let i=0;i<this.tableData.length;i++){
					totalMoney=totalMoney+this.tableData[i].price
				}
				this.totalMoney = totalMoney.toFixed(2);
			},
			// 打印发票
			getInvoice(row){
				this.$http.get('/api/Recharge/OrderRechargeReceipt', {
					orderNumber:row._id
				}).then(res => {
					if (res.code == 0) {
						let d = res.data;
						printJs.printTicketSaleOrder(d).then(r => {
							this.$store.commit("set_printUrl",r.msg)
							// if (r.url != '') {
							// 	this.printUrl = r.url;
							// 	setTimeout(() => {
							// 		this.printUrl = '';
							// 	}, 1000)
							// }
						})
						// util.print(d).then(r => {
						// 	if (r.url != '') {
						// 		this.printUrl = r.url;
						// 		setTimeout(()=>{
						// 			this.printUrl='';
						// 		},1000)
						// 	}
							
						// })
					}
				})
			},
			// 嘉联
			is_jialian(row){
				let payInfo = row.pay_info||{pay_list:[]}
				let money = 0;
				for(let i=0;i<payInfo.pay_list.length;i++){
					if(payInfo.pay_list[i].pay_type===15){
						money = payInfo.pay_list[i].money
					}
				}
				if(money>0){
					return true
				}else{
					return false
				}
			},
			checkOrderState_Jialian(row){
				this.$http.get('/api/pay/jl/payState', {shopId:this.curShopId,orderNum:row.no}).then(res => {
					if (res.code == 0) {
						if(res.data=='success'){
							this.$message({
								message: '该订单已支付，请刷新查看',
								type: 'success'
							});
						}else{
							this.$message({
								message: res.info,
								type: 'error'
							});
						}
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.page{
	.searchView {
		::v-deep .el-form-item {
			margin-bottom: 0;
			.el-form-item__label{
				padding-right: 5px;
				font-size: 12px;
			}
		}
		.tabLine{
			display: flex;
			.tabItem {
				width:88px;
				box-sizing: border-box;
				line-height: 36px;
				text-align: center;
				border-right: 1px solid #F2F2F2;
				cursor: pointer;
				font-size: 14px;
				background-color: #fff;
				&.active {
					color: $mainColor;
				}
			}
		}
		.searchBox{
			border-top:1px solid #F2F2F2;
		}
	}
	.pageConBox{
		padding:0 0px;
		min-height: 600px;
	}
}
</style>
